var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98401 4.71452L4.00715 4.71452C4.28834 4.72653 4.50976 4.95644 4.50976 5.23524L4.50976 13.493C4.50976 13.7791 4.27597 14.0143 3.98401 14.0143C3.69206 14.0143 3.45827 13.7791 3.45827 13.493L3.45828 5.23574C3.45828 4.94933 3.69193 4.71452 3.98401 4.71452Z",
    stroke: "#187C85",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12991 2.3911L7.15472 2.3911C7.45854 2.40598 7.75285 2.69239 7.75285 3.11414L7.75284 13.2906C7.75284 13.7234 7.44218 14.0143 7.12991 14.0143C6.81765 14.0143 6.50699 13.7234 6.50699 13.2906L6.50699 3.11475C6.50699 2.68152 6.81752 2.3911 7.12991 2.3911Z",
    stroke: "#187C85",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.373 1.09393L10.3961 1.09393C10.6735 1.11 10.9959 1.41364 10.9959 1.92991L10.9959 13.1776C10.9959 13.7077 10.6551 14.0143 10.373 14.0143C10.0909 14.0143 9.75009 13.7077 9.75009 13.1776L9.75009 1.93059C9.75009 1.39993 10.0908 1.09393 10.373 1.09393Z",
    stroke: "#187C85",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.513794 2.68945V15.6618H13.4862",
    stroke: "#187C85",
    strokeWidth: 0.95,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperior);
export default __webpack_public_path__ + "static/media/Superior.9c509b1c2db3b2e94f75bcd51189c72f.svg";
export { ForwardRef as ReactComponent };